import SpinTicker from "./SpinTicker";
import events from "../../events/EventsObservable";
import Reels from "./Reels";
import {REELS_EVENTS} from "./reelsEvents";

class ReelsSpinner {

    private _reels: Reels;
    private _isSpinning: boolean;
    private _ticker: SpinTicker;

    constructor(reels: Reels) {

        this._reels = reels;

        this._isSpinning = false;

        this._ticker = new SpinTicker();
    }

    create() {

        let spinners = this._reels.getSpinners();
        let spinnersLen = spinners.length;

        this._ticker.setOnLoop(delta => {
            for(let i = 0; i < spinnersLen; i++) {
                spinners[i].tick(delta);
            }
        });
    }

    /**
     * @returns {Promise}
     */
    async spin() {
        if (this._isSpinning) {
            return Promise.resolve();
        }

        this._isSpinning = true;

        events.dispatch(REELS_EVENTS.REELS_START);

        this._ticker.start();

        let allStopped = [];

        for (let i = 0; i < this._reels.getReels().length; i++) {
            let reel = this._reels.getReel(i);

            reel.preStartReel();

            let started = this._reels.startReel(i).then(() => {
                this._reels.print(i);
                reel.postStartReel();
            });

            allStopped.push(started);
        }

        await Promise.all(allStopped);
        this._ticker.stop();
        this._isSpinning = false;
        return events.dispatch(REELS_EVENTS.REELS_COMPLETE);
    }
}

export default ReelsSpinner;